import { type AuthUser, UserRoles } from '@dynamika-shared/types/auth';

/**
 * True when the user's active role is Sponsor. Prefers the explicitly selected
 * role, falling back to the roles claim in the Auth0 metadata.
 * Lifted from the inline check previously duplicated in OverviewUploadsLayout.
 */
export const getIsSponsor = (user?: AuthUser | null): boolean =>
  user?.selectedRole
    ? user.selectedRole === UserRoles.SPONSOR
    : (user?.['dynamika7/user_metadata']?.roles?.includes(UserRoles.SPONSOR) ??
      false);
